/**
 * --------------------------------------------------------------------------
 * Component Name : ConsolidatedReport.jsx
 * Created Date   : 05-Nov-2025
 * Created By     : Sreeraj
 * Description    : Displays consolidated monthly expense report from API
 * --------------------------------------------------------------------------
 */

import React, { useState } from "react";
import {
    Box,
    Typography,
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import "./ConsolidatedReport.css";

const ConsolidatedReport = ({ apiResponse = [], year, onMonthSelect,  setReportType }) => {
    const [openMonth, setOpenMonth] = useState(null);

    // Converts "Jan" -> "01", "Feb" -> "02", etc.
    const getMonthNumber = (shortMonth) => {
        const months = {
            Jan: "01",
            Feb: "02",
            Mar: "03",
            Apr: "04",
            May: "05",
            Jun: "06",
            Jul: "07",
            Aug: "08",
            Sep: "09",
            Oct: "10",
            Nov: "11",
            Dec: "12",
        };
        return months[shortMonth] || "01";
    };

    const formatMonthName = (shortMonth) => {
        const monthNames = {
            Jan: "January",
            Feb: "February",
            Mar: "March",
            Apr: "April",
            May: "May",
            Jun: "June",
            Jul: "July",
            Aug: "August",
            Sep: "September",
            Oct: "October",
            Nov: "November",
            Dec: "December",
        };
        return monthNames[shortMonth] || shortMonth;
    };

    //   const handleMonthClick = (monthShortName) => {
    //     const isOpen = openMonth === monthShortName;
    //     const monthNum = getMonthNumber(monthShortName);
    //     const formattedMonth = `${year?.$y || year}-${monthNum}`; // e.g. 2025-03

    //     // Update local collapse state
    //     setOpenMonth(isOpen ? null : monthShortName);

    //     // Send month to parent
    //     if (onMonthSelect) onMonthSelect(formattedMonth);
    //   };


    const handleMonthClick = (monthShortName) => {
        const monthNum = getMonthNumber(monthShortName);
        const formattedMonth = `${year?.$y || year}-${monthNum}`; // e.g. 2025-03

        // Send month to parent
        if (onMonthSelect) onMonthSelect(formattedMonth);
        setReportType(`detailed`)
    };

    return (
        <Box className="consolidated-report__container">
            {apiResponse.length === 0 ? (
                <Typography
                    variant="body1"
                    sx={{ textAlign: "center", mt: 4, color: "#666" }}
                >
                    No data available
                </Typography>
            ) : (
                apiResponse.map((monthData, index) => {
                    const isOpen = openMonth === monthData.month;
                    const monthName = formatMonthName(monthData.month);

                    return (
                        <Box
                            key={index}
                            className={`consolidated-report__month-box ${isOpen ? "active" : ""
                                }`}
                        >
                            {/* Month Header */}
                            <Box
                                className={`consolidated-report__month-header ${isOpen ? "expanded" : ""
                                    }`}
                                onClick={() => handleMonthClick(monthData.month)}
                            >
                                <Box className="consolidated-report__header-content">
                                    <Typography className="consolidated-report__month-title">
                                        {monthName}
                                    </Typography>
                                    <Typography className="consolidated-report__month-subtitle">
                                        Total Expenses: ₹{monthData.total_amount}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Collapsible Table */}
                            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                                {monthData.expenses?.length > 0 ? (
                                    <TableContainer
                                        component={Paper}
                                        className="consolidated-report__table-container"
                                    >
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Expense Head</TableCell>
                                                    <TableCell>Amount (₹)</TableCell>
                                                    <TableCell align="right">Created By</TableCell>
                                                    <TableCell align="right">Description</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {monthData.expenses.map((item) => (
                                                    <TableRow
                                                        key={item.id}
                                                        className="consolidated-report__table-row"
                                                    >
                                                        <TableCell>{item.head || "-"}</TableCell>
                                                        <TableCell>{item.amount || 0}</TableCell>
                                                        <TableCell align="right">
                                                            {item.created_by || "-"}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {item.description || "-"}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Typography
                                        variant="body2"
                                        sx={{ textAlign: "center", my: 2, color: "#999" }}
                                    >
                                        No expenses recorded for this month
                                    </Typography>
                                )}
                            </Collapse>
                        </Box>
                    );
                })
            )}
        </Box>
    );
};

export default ConsolidatedReport;
